<template>
  <a v-if="isExternal" :href="to" target="_blank" rel="noopener" @click="handleClick">
    <slot />
  </a>
  <router-link v-else :to="to">
    <slot />
  </router-link>
</template>

<script>
import { isExternal } from '@/utils/validate';
import { setShippersUserInfo } from '@/utils/shippers';
import { getToken } from '@/utils/auth';

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    isExternal() {
      return isExternal(this.to);
    },
    // 判断是否是智能录单下的外部链接菜单（除了智能录单本身）
    isIntellRecordExternalLink() {
      if (!this.isExternal) return false;
      // 检查是否是统一端的地址
      return (
        this.to.indexOf('shippers.nucarf.net') !== -1 ||
        this.to.indexOf('ci-shippers.nucarf.tech') !== -1
      );
    },
  },
  methods: {
    handleClick(event) {
      // 如果是智能录单下的外部链接，在跳转前存储用户信息
      if (this.isIntellRecordExternalLink) {
        const token = getToken();

        if (token) {
          // 构建统一端需要的用户信息
          const shippersInfo = {
            accessToken: token,
            userName: userName,
            phoneNo: phoneNo,
            from: 'nyb',
          };

          // 存储用户信息到 Cookie
          setShippersUserInfo(shippersInfo);
        }
      }
      // 允许默认行为继续（打开链接）
    },
  },
};
</script>
